import { useLocation, useRoutes } from "react-router-dom";
// layouts

//
import {
    HomePage,
    MainLayout,
    Page404,

} from "./elements";
import CompactLayout from "../layouts/compact/CompactLayout";

// ----------------------------------------------------------------------

export default function Router() {
    const location = useLocation();

    const routesConfig =
        [
            {
                path: "/",
                element: <MainLayout />,
                children: [
                    { element: <HomePage />, index: true },
                ],
            },
            {
                element: <CompactLayout />,
                children: [
                    { path: "404", element: <Page404 /> },
                ],
            },
        ]

    const routes = useRoutes(
        routesConfig
    );

    return routes;
}
